/**
 * Main theme JavaScript
 * Initializes all theme components
 */

(function () {
  "use strict";

  // ── Initialize Everything ──────────────────────────────────────────────────────
  function init() {
    // Wait for DOM to be ready
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
      return;
    }

    // Initialize all components (they're loaded via script tags in theme.liquid)
    if (window.CartDrawer) CartDrawer.init();
    if (window.HeaderScroll) HeaderScroll.init();
    if (window.MediaCarousel) MediaCarousel.init();
    if (window.VariantSelection) VariantSelection.init();
    if (window.ProductForm) ProductForm.init();
    if (window.Accordion) Accordion.init();
    if (window.SmoothScroll) SmoothScroll.init();
    if (window.Modal) Modal.init();

    // Update cart count on load
    if (window.CartAPI) {
      CartAPI.updateCartCount();
      // Refresh cart drawer on load to ensure it's in the correct state
      CartAPI.refreshCartDrawer();
      // Refresh cart page on load if we're on the cart page
      if (window.location.pathname.includes("/cart")) {
        CartAPI.refreshCartPage();
      }
    }
  }

  // Initialize
  init();
})();
